// extracted by mini-css-extract-plugin
export default {"wrapper":"M1PsJKXZ","_shorts":"C4Mblxkq","caption":"c961O2ci","video":"FlLXOD1N"};